import React, { useEffect, useState } from "react"
import { DatePicker } from "@material-ui/pickers"
import PropTypes from "prop-types"
import moment from "moment"
import { useDispatch, useSelector } from "react-redux"
import widgetSlice from "../../api/widgetSlice"

function noOp() {
  // basically a noOperation function, onChange is a required props
}

const { selectedValueOf } = widgetSlice.select
const { updateSelectorSelection } = widgetSlice.actions

function getValueForFormat(format, value) {
  switch (format) {
    case "MMM YYYY":
      return moment(value).endOf("month")
    case "L":
      return moment(value).endOf("day")
    case "YYYY":
      return moment(value).endOf("year")
    default:
      return value
  }
}

export default function DateSelectorWidget(props) {
  const { widgetId, defaultValue, format, hasMax, ...rest } = props
  const dispatch = useDispatch()
  const value = useSelector(selectedValueOf(widgetId))
  let maxDate
  if (format === "MMM YYYY" && hasMax) {
    maxDate = moment().endOf("month")
  }
  if (format === "L" && hasMax) {
    maxDate = moment().endOf("day")
  }
  if (format === "YYYY" && hasMax) {
    maxDate = moment().endOf("year")
  }
  /**
   * Mecanism with refresh has been implemented to handle properly specific picker
   * views, like ["month", "year"]. onChange, or onAccept can't be used as default
   * onChange handler, because they have always been triggered.
   *
   * This is the reason why I had to handle a local state here.
   */
  const [localDate, setLocalDate] = useState(value)
  const [fireUpdate, setFireUpdate] = useState(false)

  const handleChange = (val) => {
    const newValue = getValueForFormat(format, val)
    dispatch(updateSelectorSelection(widgetId, newValue))
  }

  const fireUpdateHandler = () => {
    setFireUpdate(!fireUpdate)
  }

  useEffect(() => {
    handleChange(localDate)
    // handleChange has a new ref because of Hooks #useSelectorReducer
    // localDate is changing more than I want in local component
    // it should dispatch the final value when picker is closing.
    // With the right value, (aka async deferred task)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fireUpdate])
  return (
    <DatePicker
      width="100%"
      autoOk
      variant="inline"
      inputVariant="outlined"
      size="small"
      format={format}
      value={value}
      maxDate={maxDate}
      onChange={noOp}
      onAccept={setLocalDate}
      onClose={fireUpdateHandler}
      {...rest}
    />
  )
}

DateSelectorWidget.propTypes = {
  widgetId: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  format: PropTypes.string,
  hasMax: PropTypes.bool
}

DateSelectorWidget.defaultProps = {
  format: "L",
  hasMax: false
}
